module.exports = __webpack_public_path__ + "img/huiyuanxitong.f0f5a3d1.png";